import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/home',
      name: 'home',
      // 路由懒加载 - 优化首屏加载速度
      component: () => import('../views/home.vue'),
      meta: {
        title: '首页',
      },
    },
    {
      path: '/charts',
      name: 'charts',
      component: () => import('../views/ChartShowcase.vue'),
      meta: {
        title: '图表展示',
      },
    },
    {
      path: '/quickstart',
      name: 'quickstart',
      component: () => import('../views/QuickStart.vue'),
      meta: {
        title: '快速入门',
      },
    },
    {
      path: '/tenant',
      name: 'tenant',
      component: () => import('../views/TenantDashboard.vue'),
      meta: {
        title: '租户数据汇总',
      },
    },
    {
      path: '/equipment-safety',
      name: 'equipment-safety',
      component: () => import('../views/EquipmentSafetyDashboard.vue'),
      meta: {
        title: '设备安全管理大屏',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../components/NotFound.vue'),
      meta: {
        title: '页面未找到',
      },
    },
  ],
})

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 数据可视化大屏`
  }
  next()
})

export default router
